/**
 * 错误信息字符化
 * @param {*} error 错误对象
 * @param {String} methodName 方法名称
 */
const errorFormatter = (error, methodName) => {
  // let msg = error instanceof Error ? error.toString() : error.message || JSON.stringify(error)
  let msg = error ? error.message || (error instanceof Error ? error.toString() : JSON.stringify(error)) : ''
  // 开发测试环境显示错误方法名
  if (methodName && process.env.VUE_APP_BUILD_TYPE !== 'production') {
    msg = methodName + ':' + msg
  }
  return msg
}
class UrlClass {
  constructor (url) {
    // const url = 'http://www.baidu.com/path1/path2?search1=1&search2=2#/hash1/hash2?query1=a&query2=b'
    const names = ['url', 'scheme', 'slash', 'host', 'port', 'path', 'search', 'hash']
    const regexUrl = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/
    this.result = regexUrl.exec(url).map((value, index) => {
      let missingStr = ''
      let valueStr = ''
      if (typeof (value) !== 'undefined') {
        switch (names[index]) {
          case 'hash': missingStr = '#'; break
          case 'port': missingStr = ':'; break
          case 'path': missingStr = '/'; break
          case 'search': missingStr = '?'; break
          case 'slash': missingStr = ':'; break
        }
        valueStr = missingStr + value
      }
      return valueStr
    }) || new Array(8)
  }
  get href () {
    return this.result.filter((value, index) => index > 0).join('')
  }
  get scheme () {
    return this.result[1]
  }
  set scheme (value) {
    this.result[1] = value
  }
  get slash () {
    return this.result[2]
  }
  set slash (value) {
    this.result[2] = value
  }
  get host () {
    return this.result[3]
  }
  set host (value) {
    this.result[3] = value
  }
  get port () {
    return this.result[4]
  }
  set port (value) {
    this.result[4] = value
  }
  get path () {
    return this.result[5]
  }
  set path (value) {
    this.result[5] = value
  }
  get search () {
    return this.result[6]
  }
  set search (value) {
    this.result[6] = value
  }
  get hash () {
    return this.result[7]
  }
  set hash (value) {
    this.result[7] = value
  }
}
export {
  errorFormatter,
  UrlClass
}
